var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMiximize(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 0C12.4477 0 12 0.447715 12 1C12 1.55228 12.4477 2 13 2H16.5858L11.2929 7.29289C10.9024 7.68342 10.9024 8.31658 11.2929 8.70711C11.6834 9.09763 12.3166 9.09763 12.7071 8.70711L18 3.41421V7C18 7.55228 18.4477 8 19 8C19.5523 8 20 7.55228 20 7V1C20 0.447715 19.5523 0 19 0H13Z",
    fill: "#2D3648"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 13C2 12.4477 1.55228 12 1 12C0.447715 12 0 12.4477 0 13V19C0 19.5523 0.447715 20 1 20H7C7.55228 20 8 19.5523 8 19C8 18.4477 7.55228 18 7 18H3.41421L8.70711 12.7071C9.09763 12.3166 9.09763 11.6834 8.70711 11.2929C8.31658 10.9024 7.68342 10.9024 7.29289 11.2929L2 16.5858V13Z",
    fill: "#2D3648"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiximize);
export default __webpack_public_path__ + "static/media/miximize.10a040102773cd50424f0cc87dad44e0.svg";
export { ForwardRef as ReactComponent };